import {createFileRoute, Navigate, useSearch} from '@tanstack/react-router';
import SocialGames, {SocialTab} from '../../../football/social/SocialGames';
import {useSports} from '../../../sports/registry';

/** A club's social football games (football v2). Not offered while the switch is off. */
export const Route = createFileRoute('/_app/football/social')({
    component: RouteComponent,
});

function RouteComponent() {
    const {data: registry} = useSports();
    const search = useSearch({strict: false}) as {tab?: string};
    if (registry && !(registry.multi_sport && registry.football_v2)) return <Navigate to="/football/" />;
    const tab = (['new', 'results', 'table', 'stats'] as const).find((t) => t === search.tab) ?? 'results';
    return <SocialGames initialTab={tab as SocialTab} />;
}
